import React from 'react';
import whatsapp_logo from '../../images/whatsapp_logo.png'

const WhatsAppPopup = () => {
    const phoneNumber = '9879630696'; 

    const openWhatsApp = () => {
        window.open(`https://wa.me/${phoneNumber}`, '_blank');
    };

    return (
        <div className="fixed bottom-5 left-4 z-50">
            <div className="relative flex items-center justify-center w-16 h-16 rounded-full">
                {/* Pulsing border */}
                <div className="absolute inset-0 w-full h-full rounded-full border-4 border-green-500 opacity-50 animate-ping"></div>
                <div className="absolute inset-0 w-full h-full rounded-full border-4 border-green-700 opacity-75 animate-ping delay-100"></div>

                {/* Button */}
                <button
                    onClick={openWhatsApp}
                    className="relative flex items-center justify-center w-16 h-16 rounded-full shadow-lg hover:scale-110 transition-transform duration-300"
                >
                    <img src={whatsapp_logo} alt="" />
                </button>
            </div>
        </div>
    );
};

export default WhatsAppPopup;
